import { render, staticRenderFns } from "./PagamentoClienteRead.vue?vue&type=template&id=69a1fabb&"
import script from "./PagamentoClienteRead.vue?vue&type=script&lang=js&"
export * from "./PagamentoClienteRead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports